<!-- 议政建言 -->
<template>
  <div id="Mzsm">
    <headerVue></headerVue>
    <div class="container">
      <div class="title">九三学社陕西省委员会议政建言成果提交</div>
      <!-- 循环 -->
      <div class="content">
        <el-form ref="form" :rules="rules" :model="form" label-width="120px">
          <!-- <el-form-item label="所属基层">
            <el-form-item label="所属单位">
              <el-input v-model="form.szdw"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" style="margin-top: 20px;">
              <el-input v-model="form.lxdh"></el-input>
            </el-form-item>
            <el-form-item label="反映人" style="margin-top: 20px;">
              <el-input v-model="form.fyr"></el-input>
            </el-form-item>
          </el-form-item> -->
          <el-form-item label="类型" prop="lx" style="width: 500px;">
            <el-select v-model="form.lx" placeholder="请选择" style="width: 350px;">
              <el-option label="提案报送" value="tabs"></el-option>
              <el-option label="社情民意信息报送" value="sqmyxxbs"></el-option>
              <el-option label="发言报送" value="fybs"></el-option>
              <el-option label="调研报告报送" value="dybgbs"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期" prop="cjrq">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.cjrq" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="标题" prop="bt">
            <el-input v-model="form.bt"></el-input>
          </el-form-item>
          <el-form-item label="正文" prop="zw">
            <el-input type="textarea" v-model="form.zw" style="margin-left: 30px;"></el-input>
          </el-form-item>
          <el-form-item label="反映人" prop="fyr">
            <el-input v-model="form.fyr"></el-input>
          </el-form-item>
          <el-form-item label="所属单位" prop="szdw">
            <el-input v-model="form.szdw"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="lxdh">
            <el-input v-model="form.lxdh"></el-input>
          </el-form-item>
          <el-form-item label="所属基层" prop="szjc" required>
            <el-input v-model="form.szjc"></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="fj">
            <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注" prop="bz">
            <el-input type="textarea" v-model="form.bz" style="margin-left: 30px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="submit" style="width: 200px;margin-left: 100px;">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
  name: 'Yzjy',
  data() {
    return {
      form: {
        szdw: '',
        lxdh: '',
        fyr: '',

        lx: '',
        cjrq: '',
        bt: '',
        zw: '',
        szjc: '',
        fj: '',
        bz: '',
      },
      rules:{
        szjc:[
          {required:true,message:'请输入所属基层', trigger: 'blur'}
        ]
      }
    }
  },
  created() {

  },
  methods: {

  },
  components: {
    headerVue,
    footerVue
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: auto;
  background-color: white;
  margin-top: 20px;

  .title {
    padding: 10px;
    padding-bottom: 20px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
  }

  .content {
    text-indent: 2em;
    color: #4D4F53;
    line-height: 60px;
    padding: 10px;
    width: 40%;
    margin-left: 280px;
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .container {
    width: 100%;

    .content {
      margin-left: 10px;
      width: 80%;

      // background-color: pink;
      .btn {
        margin-left: 30% !important;
      }
    }
  }
}

::v-deep .el-icon-date:before {
  content: ''
}
</style>